import { Component } from '@angular/core';
import { convertToISO } from 'app/core/shared/helper/date.helper';
import { isFormChange, onTypeChange } from 'app/core/shared/helper/equipment-registration.helper';
import { FormComponent } from 'app/modules/equipment-registration/component/form-component/form.component';
import { module } from 'app/modules/equipment-registration/equipment-registration.module';
import { Valve } from 'app/modules/equipment-registration/model/valve.model';
import { EquipRegistrationServices } from 'app/modules/equipment-registration/services/equipment-registration.service';

@Component({
  selector: 'app-wing-valve',
  templateUrl: './wing-valve.component.html',
  standalone: true,
  imports: [
    ...module,
    FormComponent
  ],
  styleUrls: ['./wing-valve.component.scss']
})
export class WingValveComponent {
  public equipmentRegistration$ = this.equipmentServices.equipmentRegistration$
  public wvForm: Valve = new Valve()
  public tempWvForm: Valve = new Valve()

  public isReplace: boolean = true;
  public disabledToggle: boolean = true;
  public wellStringId: string;

  constructor(
    private equipmentServices: EquipRegistrationServices
  ) { }

  ngOnInit() {
    this.initializeForm()

    this.equipmentRegistration$.subscribe(wellEquipment => {
      if (!wellEquipment) return '';

      this.wellStringId = wellEquipment.wellStringId

      if(wellEquipment?.wValve){
        this.wvForm = new Valve(wellEquipment?.wValve);
      } else {
        this.initializeForm()
      }

      this.handdleFormValue()
      this.isReplace = !wellEquipment?.wValve;
      this.disabledToggle = !wellEquipment?.wValve;
    })
  }

  private initializeForm(): void {
    this.wvForm.reset()
  }

  private handdleFormValue() {
    if (!this.wvForm.mdSceValveTypeId) {
      this.setSceValveTypeId()
    }

    if (!this.wvForm.sceXmasTreeId) {
      this.setXmasTreeId()
    }

    this.tempWvForm = new Valve(this.wvForm)
  }

  private setSceValveTypeId() {
    this.equipmentServices.getSceValveTypeId('WV').subscribe(id => {
      this.wvForm.mdSceValveTypeId = this.tempWvForm.mdSceValveTypeId = id
    })
  }

  private setXmasTreeId() {
    this.equipmentServices.getSceXmasTreeByStringId(this.wellStringId).subscribe(res => {
      if (res.data) {
        this.wvForm.sceXmasTreeId = this.tempWvForm.sceXmasTreeId = res.data.id
      }
    })
  }

  disabledSave(): boolean {
    return !this.wvForm.mdSceValveTypeId || !this.wvForm.sceXmasTreeId || isFormChange(this.wvForm, this.tempWvForm)
  }

  save() {
      onTypeChange(this.wvForm)
    
    const operation = this.isReplace ?
      this.equipmentServices.addSceValve(this.wvForm) :
      this.equipmentServices.updateSceValve(this.wvForm);

    operation.subscribe((res) => {
      if (res) {
        this.equipmentServices.getEquipmentRegistration(this.wellStringId).subscribe();
      }
    });
  }


}
